import adjustmentsReport from "./adjustmentsReport.json";
import batchCloseReport from "./batchCloseReport.json";
import cartDiscardedProductReport from "./cartDiscardedProductReport.json";
import cashDropReport from "./cashDropReport.json";
import cogsReport from "./cogsReport.json";
import commissionOrderDetails from "./commissionOrderDetails.json";
import common from "./common.json";
import depositReport from "./depositReport.json";
import employeeCommissionReport from "./employeeCommissionReport.json";
import endOfDayComplianceReport from "./endOfDayComplianceReport.json";
import endOfShiftReport from "./endOfShiftReport.json";
import grossProfitReport from "./grossProfitReport.json";
import inventoryMovementReport from "./inventoryMovementReport.json";
import inventoryStockReport from "./inventoryStockReport.json";
import inventorySummaryReport from "./inventorySummaryReport.json";
import loyaltyProgramReport from "./loyaltyProgramReport.json";
import netSalesReport from "./netSalesReport.json";
import productSearchModal from "./productSearchModal.json";
import refundReport from "./refundReport.json";
import returnByVendorReport from "./returnByVendorReport.json";
import returnsReport from "./returnsReport.json";
import saleByCustomerGroupReport from "./saleByCustomerGroupReport.json";
import saleByDiscountsReport from "./saleByDiscountsReport.json";
import saleByProductReport from "./saleByProductReport.json";
import salesByCategoryReport from "./salesByCategoryReport.json";
import salesByLocationReport from "./salesByLocationReport.json";
import salesByProductTypeReport from "./salesByProductTypeReport.json";
import salesByVendorReport from "./salesByVendorReport.json";
import salesReport from "./salesReport.json";
import salesSummary from "./salesSummary.json";
import storeCreditReport from "./storeCreditReport.json";
import taxReport from "./taxReport.json";
import timeCardReport from "./timeCardReport.json";
import tipReport from "./tipReport.json";
import topSellingCategoryReport from "./topSellingCategoryReport.json";
import transactionReport from "./transactionReport.json";
import voidTransactionReport from "./voidTransactionReport.json";

// One file per report keeps the 33 report screens manageable; this barrel
// assembles them into the single `reports` i18n namespace. Add a new report by
// dropping in its JSON and adding it here — src/i18n/index.ts stays untouched.
const reports = {
  adjustmentsReport,
  batchCloseReport,
  cartDiscardedProductReport,
  cashDropReport,
  cogsReport,
  commissionOrderDetails,
  common,
  depositReport,
  employeeCommissionReport,
  endOfDayComplianceReport,
  endOfShiftReport,
  grossProfitReport,
  inventoryMovementReport,
  inventoryStockReport,
  inventorySummaryReport,
  loyaltyProgramReport,
  netSalesReport,
  productSearchModal,
  refundReport,
  returnByVendorReport,
  returnsReport,
  saleByCustomerGroupReport,
  saleByDiscountsReport,
  saleByProductReport,
  salesByCategoryReport,
  salesByLocationReport,
  salesByProductTypeReport,
  salesByVendorReport,
  salesReport,
  salesSummary,
  storeCreditReport,
  taxReport,
  timeCardReport,
  tipReport,
  topSellingCategoryReport,
  transactionReport,
  voidTransactionReport,
};

export default reports;
